import dayjs from 'dayjs';
import SalaryIncreaseStep from './SalaryIncreaseStep.js';

export default class PayrollRank {
  constructor(data) {
    this.id = data?.id;
    this.organizationId = data?.organizationId;
    this.name = data?.name;
    this.minValue = data?.minValue ? Number(data.minValue) : null;
    this.maxValue = data?.maxValue ? Number(data.maxValue) : null;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.salaryIncreaseSteps = data?.salaryIncreaseSteps ? data?.salaryIncreaseSteps.map(s => new SalaryIncreaseStep(s)) : [];
  }
}
